<div class="xero-client-tasks-left" [ngClass]="{ 'component-loading': loading }">
  <div
    *ngIf="!hasXeroItems()"
    class="empty-wrapper"
    class="empty-wrapper"
  >
    <div>
      <div class="emoji">
        <img
          src="/assets/img/Enthusiastic-pana.svg"
          style="margin-bottom: 32px"
        />
      </div>
      <h4>Yay!</h4>
      <p>No transactions to recategorize.</p>
    </div>
  </div>

  <h2
    *ngIf="hasXeroItems()"
    style="margin-top: -11px"
  >
    Please classify the following transactions
  </h2>
  <h5
    style="text-transform: uppercase; margin-top: 40px"
    *ngIf="hasXeroItems()"
  >
    Xero Transactions
  </h5>
  <div>
    <app-xero-client-task-item
      [xeroTrackedItems]="xeroTrackedItems"
      [company]="company"
      (selectedTrackedItem)="selectTrackedItem($event)"
      [availableAccounts]="availableAccounts"
    ></app-xero-client-task-item>
  </div>
</div>

<div class="xero-client-tasks-right">
  <div class="empty-state" *ngIf="selectedTrackedItem == null">
    <svg
      width="66"
      height="58"
      viewBox="0 0 66 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44.3412 40.9371L28.3902 26.0269C28.0753 25.7336 27.6161 25.6543 27.2211 25.8251C26.8261 25.9967 26.571 26.3859 26.571 26.8169V48.4404C26.571 48.8563 26.8096 49.2354 27.1844 49.4149C27.5585 49.5958 28.0039 49.5447 28.3283 49.2845L32.7337 45.7584L36.8976 55.3491C37.1355 55.8969 37.7727 56.1485 38.3198 55.9099L41.6253 54.4741C42.1731 54.2362 42.4239 53.5998 42.186 53.052L39.992 47.9986L38.0221 43.462L43.7264 42.8024C44.1451 42.7542 44.4976 42.4666 44.6295 42.0665C44.7614 41.665 44.649 41.2254 44.3412 40.9371Z"
        fill="#151C29"
      />
      <path
        d="M19.1109 30.6468L8.94971 34.6233"
        stroke="#959DAB"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M47.6245 19.4881L37.4633 23.4647"
        stroke="#959DAB"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M21.4349 9.56509L25.4114 19.7263"
        stroke="#959DAB"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M10.8109 18.8923L20.3718 24.1507"
        stroke="#959DAB"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M35.2312 9.09481L31.9558 19.5032"
        stroke="#959DAB"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
    <h4>Select a task</h4>
    <p>Click a task to see it’s attachments and comments.</p>
  </div>

  <div>
    <div *ngIf="selectedTrackedItem != null" class="xero-transaction-dropdown">
      <h4>Xero Transaction</h4>

      <div dropdown [autoClose]="true" container="body" placement="bottom right">
        <span
          class="tracked-item-more-options"
          id="{{ selectedTrackedItem.id }}"
          type="button"
          dropdownToggle
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="feather more-horizontal"></i>
        </span>
        <ul
          *dropdownMenu
          class="dropdown-menu pull-right"
          [attr.aria-labelledby]="selectedTrackedItem.id"
          style="right: 0; left: auto;"
        >
          <li class="dropdown-header" style="padding: 3px 14px">ACTIONS</li>

          <li (click)="openDeleteTrackedItemModal()">
            <a>Delete Task</a>
          </li>
        </ul>
      </div>
      <div class="qb-card-wrapper" style="height: 117px">
        <div>
          <div class="qb-card-first-line">
            <div
              class="qb-card-tag qb-card-account"
              tooltip="Bank Transactions"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 8V5C17 4.73478 16.8946 4.48043 16.7071 4.29289C16.5196 4.10536 16.2652 4 16 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6M4 6C4 6.53043 4.21071 7.03914 4.58579 7.41421C4.96086 7.78929 5.46957 8 6 8H18C18.2652 8 18.5196 8.10536 18.7071 8.29289C18.8946 8.48043 19 8.73478 19 9V12M4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H18C18.2652 20 18.5196 19.8946 18.7071 19.7071C18.8946 19.5196 19 19.2652 19 19V16"
                  stroke="#151C29"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20 12V16H16C15.4696 16 14.9609 15.7893 14.5858 15.4142C14.2107 15.0391 14 14.5304 14 14C14 13.4696 14.2107 12.9609 14.5858 12.5858C14.9609 12.2107 15.4696 12 16 12H20Z"
                  stroke="#151C29"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Bank Transactions
            </div>
            <div class="arrow">
              <svg
                style="margin-top: -6px;"
                width="9"
                height="16"
                viewBox="0 0 9 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L8.70711 7.29289C9.09763 7.68342 9.09763 8.31658 8.70711 8.70711L1.70711 15.7071C1.31658 16.0976 0.683417 16.0976 0.292893 15.7071C-0.0976311 15.3166 -0.0976311 14.6834 0.292893 14.2929L6.58579 8L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                  fill="#151C29"
                />
              </svg>
            </div>
            <div class="qb-card-tag qb-card-amount">
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.8472 1V23"
                  stroke="#151C29"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.8472 5H10.3472C9.41891 5 8.52867 5.36875 7.87229 6.02513C7.21592 6.6815 6.84717 7.57174 6.84717 8.5C6.84717 9.42826 7.21592 10.3185 7.87229 10.9749C8.52867 11.6313 9.41891 12 10.3472 12H15.3472C16.2754 12 17.1657 12.3687 17.822 13.0251C18.4784 13.6815 18.8472 14.5717 18.8472 15.5C18.8472 16.4283 18.4784 17.3185 17.822 17.9749C17.1657 18.6313 16.2754 19 15.3472 19H6.84717"
                  stroke="#151C29"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span
                *ngIf="
                selectedTrackedItem?.integration_data.transaction_body.Total.toString().includes('.')
                "
                >${{ selectedTrackedItem?.integration_data.transaction_body.Total }}</span
              >
              <span
                *ngIf="
                  !selectedTrackedItem?.integration_data.transaction_body.Total.toString().includes('.')
                "
                >${{ selectedTrackedItem?.integration_data.transaction_body.Total }}.00</span
              >
            </div>
          </div>
          <div class="qb-card-second-line">
            <div
              class="qb-card-tag qb-card-payee"
              tooltip="{{ selectedTrackedItem?.integration_data.transaction_body.Contact.Name }}"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                  stroke="#151C29"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                  stroke="#151C29"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>{{ selectedTrackedItem?.integration_data.transaction_body.Contact.Name }}</span>
            </div>
            <div class="qb-card-tag qb-card-date">
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.9082 4H5.9082C4.80363 4 3.9082 4.89543 3.9082 6V20C3.9082 21.1046 4.80363 22 5.9082 22H19.9082C21.0128 22 21.9082 21.1046 21.9082 20V6C21.9082 4.89543 21.0128 4 19.9082 4Z"
                  stroke="#151C29"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.9082 2V6"
                  stroke="#151C29"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.9082 2V6"
                  stroke="#151C29"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M3.9082 10H21.9082"
                  stroke="#151C29"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              {{ selectedTrackedItem?.integration_data.transaction_body.DateString | amDateFormat : "ll" }}
            </div>
          </div>
        </div>
        <!-- <div
          class="qb-card-description"
          tooltip="Description"
          style="
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 333px;
          "
        >
          Description
        </div> -->
      </div>
      <div
        class="answer-text"
        *ngIf="selectedTrackedItem?.answer_status != 'open'"
      >
        Answered by {{ selectedTrackedItem?.answer_user.full_name }} at
        {{
          selectedTrackedItem?.last_answered
            | amCalendar : moment_calendar_format
        }}
      </div>
      <hr />
    </div>
    <ch-client-task-comments
      *ngIf="selectedTrackedItem != null"
      class="xero-comments"
      [trackedItem]="selectedTrackedItem"
    ></ch-client-task-comments>
  </div>
</div>
